var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocationWithCircle = function SvgLocationWithCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#f7f9fc"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 56.5a7.027 7.027 0 0 1-5.748-2.933c-5.081-7.009-7.659-12.278-7.659-15.661a13.405 13.405 0 0 1 22.887-9.48 13.405 13.405 0 0 1 3.927 9.48c0 3.383-2.578 8.652-7.659 15.66A7.027 7.027 0 0 1 40 56.5Zm0-29.09a10.511 10.511 0 0 0-10.499 10.498c0 2.68 2.524 7.636 7.106 13.954a4.192 4.192 0 0 0 6.786 0c4.582-6.319 7.106-11.274 7.106-13.954A10.51 10.51 0 0 0 40 27.41Z",
    fill: "#1C7CE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 32.502a5.334 5.334 0 1 0 0 10.668 5.334 5.334 0 0 0 0-10.668Zm0 8a2.667 2.667 0 1 1 0-5.334 2.667 2.667 0 0 1 0 5.333Z",
    fill: "#1C7CE5"
  })));
};
export default SvgLocationWithCircle;